export default __webpack_public_path__ + "static/media/svg-7.a196b514.svg";